import { useLiveQuery } from 'dexie-react-hooks';
import { CloudOff, CloudUpload } from 'lucide-react';
import { useTranslation } from '@/shared/i18n/use-translation';
import { replica } from '@/shared/sync/replica';

type AttachmentSyncMarkProps = {
  readonly sha256: string;
};

export function AttachmentSyncMark({ sha256 }: AttachmentSyncMarkProps) {
  const { t } = useTranslation();
  const stored = useLiveQuery(() => replica.db.blobs.get(sha256), [sha256]);
  if (stored === undefined) {
    return (
      <span className="flex items-center gap-1 text-xs text-muted-foreground">
        <CloudOff className="size-3" /> {t('Not on this device yet')}
      </span>
    );
  }
  if (!stored.uploaded) {
    return (
      <span className="flex items-center gap-1 text-xs text-muted-foreground">
        <CloudUpload className="size-3" /> {t('Waiting to upload')}
      </span>
    );
  }
  return null;
}
